import {Component, EventEmitter, Input, Output} from '@angular/core';

// Path: src/app/components/buttons/button/button.component.ts
@Component({
    selector: 'mwo-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
    private _svgIcon: string;
    private _isSvgIconHovered: boolean = false;
    private _active: boolean;

    @Input()
    set active(value: boolean) {
        this._active = value;
    }

    get active(): boolean {
        return this._active;
    }

    @Input() disable: boolean = false
    @Input() icon: string;
    @Input() noShadow: boolean = false;
  @Input() noActiveColor: boolean = false;
    /***
     * This is the input for the svg icon
     * It will automatically add the suffix "_active" if the button is active
     * as from the icon registry, the active icon is registered with the suffix "_active"
     * and can't be used directly in the mat-icon
     */
    @Input()
    set svgIcon(value: string) {
        this._svgIcon = value;
    }

    get svgIcon(): string {
        return this.active || this._isSvgIconHovered ? this._svgIcon + '_active' : this._svgIcon;
    }

    @Input('payload') payload: any;

    // output on click that I can trigger from the mat-btn
    @Output() onClick = new EventEmitter();

    constructor() { }

    click() {
        if (this.payload) {
            this.onClick.emit(this.payload);
        } else {
            this.onClick.emit();
        }
    }

    onMouseEnter() {
        this._isSvgIconHovered = true;
    }

    onMouseLeave() {
        this._isSvgIconHovered = false;
    }

}
